import 'UI/Widget/Forms/Control/Input'

NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.CheckboxLabel = Class(UI.Widget.Forms.Control.Input, {
    $input: null,

    createElement: function() {
        var onClick = this.$control.attr("on-click");
        var title = this.$control.attr("title");

        this.$element = $("<label><input type='checkbox' /><span>" + title + "</span></label>");
        this.$input = this.$element.find("input");

        if (onClick) {
            this.$input.attr("on-click", onClick);
        }
    },

    updateElement: function(value) {
        this.$input.prop("checked", !!value);
    },

    listenElement: function() {
        var self = this;

        this.$input.on("click", function() {
            self.setValue($(this).is(":checked"));
        });
    },

    editMode () {
        this.ParentCall()
        this.$element.prop('disabled', false)
    },
    viewMode () {
        this.ParentCall()
        this.$element.prop('disabled', true)
    },
});

